import React from 'react';

import { useBlockingRouter } from '../../../hooks/useBlockingRouter';
import {
	CustomListItemComponent,
	CustomListItemType,
} from './CustomListItemComponent';

export default function CustomListItemContainer( {
	listItem,
}: {
	listItem: CustomListItemType;
} ) {
	const router = useBlockingRouter();
	const isActive = 'href' in listItem ? listItem.href === router.asPath : false;

	return (
		<CustomListItemComponent listItem={ { ...listItem, isActive: isActive } } />
	);
}
